import {FC} from 'react'

interface Props {
    name:string
}

const CampaignRow: FC<Props> = ({ name}) => {
    return (
        <tr className="woocommerce-table__line-item order_item campaign_row_spec">
            <td colSpan={2} className="woocommerce-table__product-name product-name">{name}</td>
        </tr>
    )
};

export default CampaignRow
